import noop from 'lodash/noop';
import {createEventHandler} from 'recompose';
import {createToggleOnceState} from '../react-utils';
import {createFilteredReduxList} from './ReduxListContainer';


/**
 * @param {Object} config
 * @param {String} config.listProp The prop name that the list props will be set to as an object
 * @param {function(Object): !String} [config.getParentId=noop] Get the relevant list parent ID from props, if needed
 * @param {ReduxList} config.reduxList
 * @param {ReduxListComponentOptions} config.options
 * @param {Observable} config.state$
 * @param {Function} config.dispatch
 * @param {Observable} config.props$
 * @return {Observable<{[listProp]: ReduxDropdownListProps}>}
 */
export function createReduxDropdownList(config) {
  const {
    listProp,
    getParentId = noop,
    getLabel,
    reduxList,
    options,
    state$,
    dispatch,
    props$,
    baseFilterData = {},
  } = config;

  /** @type {ReduxObservableListActions} */
  const actions = reduxList.actions;

  const {
    handler: onFocus,
    stream: focus$,
  } = createEventHandler();

  const {
    handler: onInit,
    stream: init$,
  } = createToggleOnceState(props$);

  focus$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([isOpen, props]) => {
      onInit();

      const filterData = {
        ...baseFilterData,
        filter: '',
      };

      dispatch(actions.applyFilter(filterData, {parentId: getParentId(props)}));
    });

  const injectedListProps$ = props$
    .combineLatest(
      init$,
      (props, focus) => ({
        ...props,
        init: props.init !== false && focus,
        parentId: getParentId(props),
      }));

  const {
    onFilterChange,
    onLoadMore,
    listProps$,
  } = createFilteredReduxList(reduxList, options, state$, dispatch, injectedListProps$);

  const dropdownProps$ = listProps$
    .map(props => ({
      [listProp]: {
        options: listToOptions(props.list, getLabel),
        mode: props.mode,
        total: props.total,
        onFocus,
        onFilterChange,
        onLoadMore,
        getLabel,
      },
    }));

  return {
    dropdownProps$,
  };
}

// TODO: optionally inject null option if field is nullable
function listToOptions(list, getLabel) {
  return list
    .map(model => ({
      value: model,
      label: getLabel(model),
    }));
}

/**
 * @typedef {Object} ReduxDropdownListProps
 * @property {Array<{value: Object, label: String}>} options
 * @property {ViewMode} mode
 * @property {Function} onFocus
 * @property {Function} onFilterChange
 * @property {Function} onLoadMore
 * @property {Function} getLabel
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/ReduxDropdownListContainer.js